module.exports = __webpack_public_path__ + "img/igor.61d10cfe.png";